import { render, staticRenderFns } from "./SeriousDis.vue?vue&type=template&id=6ad94df0&scoped=true&"
import script from "./SeriousDis.vue?vue&type=script&lang=js&"
export * from "./SeriousDis.vue?vue&type=script&lang=js&"
import style0 from "./SeriousDis.vue?vue&type=style&index=0&id=6ad94df0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad94df0",
  null
  
)

export default component.exports